import { Navbar } from './navbar.component';

export default Navbar;
